import { createSlice } from '@reduxjs/toolkit';
import { ProductCompletionSheetDetailStateType } from 'src/types/productCompletionSheetDetail';

const initialState: ProductCompletionSheetDetailStateType = {
    data: null,
    loading: false,
    error: false,
};
export const productCompletionSheetDetailSlice = createSlice({
    name: 'productCompletionSheetDetail',
    initialState,
    reducers: {
        getProductCompletionSheetDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getProductCompletionSheetDetailFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getProductCompletionSheetDetailFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        createProductCompletionSheetDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        createProductCompletionSheetDetailFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        createProductCompletionSheetDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        updateProductCompletionSheetDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        updateProductCompletionSheetDetailFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        updateProductCompletionSheetDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        clearProductCompletionSheetDetail: () => initialState,
    },
});

export const {
    getProductCompletionSheetDetailFetch,
    getProductCompletionSheetDetailFetchSuccess,
    getProductCompletionSheetDetailFetchFailure,
    createProductCompletionSheetDetailFetch,
    createProductCompletionSheetDetailFetchSuccess,
    createProductCompletionSheetDetailFetchFailure,
    updateProductCompletionSheetDetailFetch,
    updateProductCompletionSheetDetailFetchSuccess,
    updateProductCompletionSheetDetailFetchFailure,
    clearProductCompletionSheetDetail,
} = productCompletionSheetDetailSlice.actions;

export default productCompletionSheetDetailSlice.reducer;
